import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid, TextField } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import Moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: "center",
    marginBottom: '20px'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  searchBtn: {
    marginTop: '8px',
    marginLeft: '5px'
  }
}));

const DateSearch = props => {

  const [state, setState] = React.useState({
    textFieldValue: ''
  });

  const handleOnChange = (event) => {

    if (event.target.value !== "") {

      var date_regex = /^(19|20)\d\d([- /.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])$/;
      if (!(date_regex.test(event.target.value))) {
        return false;
      }

      setState({ ...state, textFieldValue: event.target.value })

      props.SearchDates(event.target.value);
    }
  }

  useEffect(() => {
    setState({ ...state, textFieldValue: props.defaultDate });
  }, [props.defaultDate]);

  useEffect(() => {
    //props.SearchDates(props.defaultDate);
  }, []);

  const classes = useStyles();
  return (
    <Grid container spacing={3} className={classes.root}>
      <TextField
        id="fromDate"
        label="Search"
        type="date"
        // defaultValue={props.defaultDate}
        className={classes.textField}
        value={state.textFieldValue}
        onChange={handleOnChange}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: Moment(new Date()).format('YYYY-MM-DD')
        }}
      />

    </Grid>
  );
}

export default DateSearch;
